import { createApiErrorHandler } from '@m43/core';
import { useApiClient } from '~/api-client';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useToast } from '@cad-arc';
import { AxiosResponse } from 'axios-cad-nx';
import { ApiResultBoolean } from '@mark43/cad-api';
import { useBroadcast } from '../../common/broadcast-channel/use-broadcast';
import { errorOccurredWhile } from '../../common/helpers/error-occurred-while';
import { useDexResults } from './use-dex-results';
import { DexMessagesincomingResource } from '@mark43/dex-api';

export function useClearDexResultsMutation(): UseMutationResult<
    AxiosResponse<ApiResultBoolean, any>,
    unknown,
    void,
    unknown
> {
    const apiClient = useApiClient();
    const { dexResultsStore } = useDexResults();
    const { postMessage } = useBroadcast('dex-results');
    const toast = useToast();
    return useMutation(
        () => {
            const latestStoredDexMessageId = dexResultsStore.latestStoredDexMessageId ?? -1;
            return apiClient.request<DexMessagesincomingResource.UpsertResultFilterMarker>({
                service: 'DEX',
                method: 'POST',
                url: 'dex_messages/incoming/filter_marker',
                data: {
                    markerId: latestStoredDexMessageId,
                },
            });
        },
        {
            onSuccess() {
                postMessage({ type: 'REFETCH_DEX_RESULTS' });
            },
            onError: createApiErrorHandler(() => {
                toast({
                    status: 'error',
                    description: errorOccurredWhile('clearing DEx results'),
                });
            }),
        }
    );
}
